import { createSlice } from '@reduxjs/toolkit';

interface WorkspaceSlice {
  workspace: {
    id: string;
    createdAt?: string;
    updatedAt?: string;
    name?: string;
  };
}

const initialState: WorkspaceSlice = {
  workspace: {
    id: '',
    createdAt: '',
    updatedAt: '',
    name: '',
  },
};

export const workspaceSlice = createSlice({
  name: 'workspace',
  initialState,
  reducers: {
    selectWorkspace: (state, { payload }) => {
      state.workspace = { ...payload, header: {} };
    },
    resetWorkspace: (state) => {
      state.workspace = initialState.workspace;
    },
    setWorkspace: (state, action) => {
      state.workspace = action.payload;
    },
    removeWorkspace: (state) => {
      // @ts-ignore
      state.workspace = { id: '' };
    },
  },
});

export const {
  setWorkspace,
  removeWorkspace,
  resetWorkspace,
  selectWorkspace,
} = workspaceSlice.actions;

export default workspaceSlice.reducer;
